// extracted by mini-css-extract-plugin
module.exports = {"CatchImageContainer":"CatchHeader_CatchImageContainer__3d86u","ImgDimentions":"CatchHeader_ImgDimentions__uczP3"};